import React, { PropTypes } from 'react'
import styled from 'styled-components'
import { Colors, Fonts, Metrics } from '../../Themes'

const propTypes = {
  text: PropTypes.string.isRequired,
  icon: PropTypes.node,
  color: PropTypes.string
}

const TagContainer = styled.span`
  padding: ${Metrics.margins.small};
  margin-right: ${Metrics.margins.tiny};
  margin-top: ${Metrics.margins.tiny};
  display: inline-block;
  background: ${props => (props.color ? props.color : Colors.darkGrey)};
  border-radius: ${Metrics.borders.defaultRadius};
`

const TextContainer = styled.span`
  display: inline-block;
  ${Fonts.style.Input};
  color: ${Colors.white};
`
const IconContainer = styled.div`
  display: inline-block;
  margin-left: ${Metrics.margins.small};
  vertical-align: middle;

  svg {
    width: 16px;
    height: 16px;
    vertical-align: middle;
    fill: ${Colors.white};
    cursor: pointer;
  }
`

const Tag = props => {
  const { text, icon } = props

  const tagIcon = icon ? <IconContainer>{icon}</IconContainer> : null

  return (
    <TagContainer {...props}>
      <TextContainer>{text}</TextContainer>
      {tagIcon}
    </TagContainer>
  )
}

Tag.propTypes = propTypes

export default Tag



// WEBPACK FOOTER //
// ./src/components/Tag/index.js